import { render, staticRenderFns } from "./TopAnalysis.vue?vue&type=template&id=1dbe1ec8&scoped=true"
import script from "./TopAnalysis.vue?vue&type=script&lang=js"
export * from "./TopAnalysis.vue?vue&type=script&lang=js"
import style0 from "./TopAnalysis.vue?vue&type=style&index=0&id=1dbe1ec8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbe1ec8",
  null
  
)

export default component.exports